import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";

export function FoundationDonations() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/foundation/donations").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  return (
    <section className="w-full max-w-2xl mt-12 mb-4 px-4 fade-in" data-testid="foundation-donations">
      <h2 className="text-xs tracking-widest mb-4 pb-2" style={{ color: "var(--text-muted)", borderBottom: "1px solid var(--border)" }}>mawilu foundation donations</h2>
      {items.length === 0 ? (
        <p className="text-sm tracking-widest" style={{ color: "var(--text-secondary)" }} data-testid="foundation-donations-empty">no donations yet</p>
      ) : (
        <ul className="flex flex-col gap-10" data-testid="foundation-donations-list">
          {items.map((d) => (
            <li key={d.id} data-testid={`foundation-donation-${d.id}`}>
              <video controls playsInline preload="metadata" src={`${API}/foundation/donations/${d.id}/video`}
                className="w-full h-auto max-h-[75vh] bg-black" style={{ border: "1px solid var(--border)" }} data-testid={`foundation-donation-video-${d.id}`} />
              <div className="flex justify-between text-sm mt-3">
                <span style={{ color: "var(--text-muted)" }}>{d.date}</span>
                <span style={{ color: "var(--accent)" }}>${Number(d.amount_cad).toFixed(2)} CAD</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
